import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, AlertController, LoadingController, ActionSheetController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';

import { PunchCardRedeem } from '../../models/punch-card-redeem';
import { PunchCard } from '../../models/punch-card';

import { BusinessPunchCardUserRewardManagerHandler } from '../../providers/business-punch-card-user-reward-handler';
import { ConsumerHandlerProvider } from '../../providers/consumer-handler';

import { Globals } from '../../providers/globals';

@Component({
  selector: 'page-business-reward-redeem',
  templateUrl: 'business-reward-redeem.html',
})
export class BusinessRewardRedeemPage {
	rewardRedeem: any;
  reward: any;
  rewardInfo: any;
  scannedIds: any;
  hasReward: boolean;
  filePath: any;
  loader: any;
  isLoading: boolean = false;
  rewardRefreshDone: boolean = false;
  leftView: boolean = false;
  currentMasterId: any = '';
  isRedeemed: boolean = false;  
  isRedeeming: boolean = false;

  constructor(
  	public navCtrl: NavController, 
    public viewCtrl: ViewController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public consumerHandlerProvider: ConsumerHandlerProvider,
    public punchCardUserRewardManagerHandler: BusinessPunchCardUserRewardManagerHandler,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    public globals: Globals,
    public actionSheetCtrl: ActionSheetController) {
  	
  	this.rewardInfo = navParams.get('rewardRedeem');

    console.log("HOLA I AM IN HERE SENOR");

    this.rewardRedeem = {
      RewardId: this.rewardInfo[0],
      UserId: parseInt(this.rewardInfo[1])
    };

    this.consumerHandlerProvider.currentIdentityUserId = this.rewardRedeem.UserId;

    this.isLoading = true;

    try{
      var idArr = this.rewardRedeem.RewardId.split("-");

      if(idArr.length<=1){
        this.showError("This is not a reward");

        this.isLoading = false; 

        this.navCtrl.pop();          
      }else{
        this.loadReward(true); 
      }
    }catch(e){}   
  }

  showError(errorMsg){
    let alert = this.alertCtrl.create({
      title: 'Error',
      subTitle: errorMsg,
      buttons: ['Ok']
    });

    alert.present();    
  }  

  loadReward(displayErr){
    console.log('loadpunchcard userid: ' + this.rewardRedeem.UserId);

    this.punchCardUserRewardManagerHandler.getReward({
      rewardId: this.rewardRedeem.RewardId,
      userId: this.rewardRedeem.UserId,
      cb:(result)=>{
        if(!displayErr) return;

        if(result.Success){
          console.log("HOLA I AM IN CALLBACK");

          console.log(result.Data);

          this.reward = result.Data;

          this.isRedeemed = result.Data.RedeemDate ? true : false;
          
          if(!this.rewardRefreshDone){
            this.isLoading = false;      
          }     
        } else { 
          this.showError(result.Message)

          this.isLoading = false; 

          this.navCtrl.pop();
        }
      }
    })
  }

  redeemReward(){
    if(this.isRedeeming) return;

    this.isRedeeming = true;

    this.punchCardUserRewardManagerHandler.redeemReward({
      RewardId: this.rewardRedeem.RewardId,
      UserId: this.rewardRedeem.UserId,
      cb:(result)=>{
          let alert = this.alertCtrl.create({
            title: 'Success',
            subTitle: 'Reward has been redeemed!',
            buttons: ['Ok']
          });

          alert.present();

          this.loadReward(false);

          this.isRedeemed = true

          this.isRedeeming = false;
      }
    })

  }

  cancelRewardRedeem(){
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/business-reward-redeem/business-reward-redeem.ts